<div
  class="lg:relative lg:h-full bg-white rounded-lg"
  [class.z-3]="!isCollapsed()"
  [class.absolute]="!isCollapsed()"
  [class.overflow-y-auto]="model() === sidenavRoles.admin && !isCollapsed()"
  [class.lg:overflow-y-visible]="
    model() === sidenavRoles.admin && !isCollapsed()
  "
  [class]="
    (model() !== sidenavRoles.admin && !isCollapsed()) ||
    (model() === sidenavRoles.admin && !isCollapsed())
      ? 'h-[calc(100%-2.125rem)]'
      : 'h-full'
  ">
  @if (model() === sidenavRoles.admin) {
    <div
      class="bg-destructive-700 h-[3rem] flex items-center justify-center text-white gap-sm rounded-t-lg">
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.7583 4.8763L11.8083 2.01797C11 1.5513 10 1.5513 9.18333 2.01797L4.24167 4.8763C3.43333 5.34297 2.93333 6.20964 2.93333 7.1513V12.8513C2.93333 13.7846 3.43333 14.6513 4.24167 15.1263L9.19167 17.9846C10 18.4513 11 18.4513 11.8167 17.9846L16.7667 15.1263C17.575 14.6596 18.075 13.793 18.075 12.8513V7.1513C18.0667 6.20964 17.5667 5.3513 16.7583 4.8763ZM10.5 6.11797C11.575 6.11797 12.4417 6.98464 12.4417 8.05964C12.4417 9.13464 11.575 10.0013 10.5 10.0013C9.425 10.0013 8.55833 9.13464 8.55833 8.05964C8.55833 6.99297 9.425 6.11797 10.5 6.11797ZM12.7333 13.8846H8.26667C7.59167 13.8846 7.2 13.1346 7.575 12.5763C8.14167 11.7346 9.24167 11.168 10.5 11.168C11.7583 11.168 12.8583 11.7346 13.425 12.5763C13.8 13.1263 13.4 13.8846 12.7333 13.8846Z"
          fill="white" />
      </svg>

      <span class="text-xs font-semibold" [class.hidden]="isCollapsed()">
        {{ 'admin_dashboard_label' | transloco }}
      </span>
    </div>
  }

  <div
    class="flex"
    [class]="
      model() === sidenavRoles.admin
        ? 'h-[calc(100%-3rem)] overflow-x-hidden'
        : 'h-full'
    "
    [class.overflow-y-auto]="
      model() !== sidenavRoles.admin && !quickAction()?.isQuickActionOpen()
    ">
    <div
      class="transition-[width] duration-300 flex flex-col justify-between p-2xl"
      [class.collapsed]="isCollapsed()"
      [class.w-[5.625rem]]="isCollapsed()"
      [class.w-[18rem]]="!isCollapsed()">
      <ul class="list-none">
        <div class="h-full flex flex-col items-start justify-between">
          <div class="w-full">
            @if (showQuickAction()) {
              <div class="mb-2xl">
                <lib-quick-action
                  #quickAction
                  [quickActionItems]="quickActionItems()"
                  [isSideMenuCollapsed]="isCollapsed()">
                </lib-quick-action>
              </div>
            }

            @for (item of menuItems(); track $index; let last = $last) {
              <li>
                <a
                  [class.mb-lg]="!last"
                  class="relative whitespace-nowrap flex items-center py-sm px-md rounded-md hover:bg-neutral-50"
                  (click)="toggleSubMenu(item)"
                  [routerLink]="item.path ? [item.path] : null"
                  routerLinkActive="bg-primary-50 text-primary-700"
                  [class.justify-between]="!isCollapsed()"
                  [class.justify-center]="isCollapsed()"
                  [class.bg-primary-50]="item.hasActiveChild && isCollapsed()"
                  [class.text-primary-700]="
                    item.hasActiveChild && isCollapsed()
                  ">
                  <div class="flex items-center">
                    <div
                      class="flex items-center"
                      [class.pe-sm]="!isCollapsed()">
                      @let isActive =
                        (item.active &&
                          item.path &&
                          router.url.includes(item.path)) ||
                        (item.hasActiveChild && isCollapsed());
                      @if (item.iconTemplate) {
                        <ng-container
                          [ngTemplateOutlet]="item.iconTemplate"
                          [ngTemplateOutletContext]="{ $implicit: isActive }" />
                      }
                    </div>

                    @if (!isCollapsed()) {
                      <span
                        routerLinkActive="text-primary-700"
                        class="text-xs font-medium text-neutral-700">
                        {{ item.label }}
                      </span>
                    }
                  </div>

                  @if (item.children?.length && !isCollapsed()) {
                    @if (!item.expanded) {
                      <lib-chevron-down-icon
                        iconClass="size-5 text-neutral-500" />
                    } @else {
                      <lib-chevron-up-icon
                        iconClass="size-5 text-neutral-500" />
                    }
                  }
                </a>

                @if (item.children?.length && item.expanded) {
                  <ul
                    class="list-none whitespace-nowrap"
                    [class.hidden]="isCollapsed()"
                    [class.lg:block]="isCollapsed()">
                    @for (
                      subItem of item.children;
                      track $index;
                      let lastChild = $last
                    ) {
                      <li class="cursor-pointer hover:bg-neutral-50">
                        <a
                          routerLinkActive="bg-primary-50 text-primary-700"
                          [class.my-sm]="!lastChild"
                          [class.mb-lg]="lastChild"
                          class="flex items-center justify-between py-sm px-4xl my-sm rounded-md"
                          (click)="collapseSidenav()"
                          [routerLink]="[subItem.path]">
                          <span
                            routerLinkActive="text-primary-700"
                            class="text-xs font-medium text-neutral-500 ps-sm">
                            {{ subItem.label }}
                          </span>
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </div>
        </div>
      </ul>

      <div class="flex flex-col gap-2xl">
        <button
          type="button"
          class="flex px-md py-sm"
          (click)="toggleSidenav()">
          <span [class.rotate-180]="isCollapsed()">
            <lib-arrow-left-icon iconClass="size-5 text-neutral-500" />
          </span>
        </button>

        <ul class="list-none border-t border-neutral-200">
          @for (item of footerItems(); track $index) {
            <li>
              <a
                class="relative whitespace-nowrap flex items-center justify-between py-sm px-md my-lg rounded-md bg-white text-neutral-600 cursor-pointer"
                [class.justify-between]="!isCollapsed()"
                [class.justify-center]="isCollapsed()"
                (click)="toggleSubMenu(item)"
                [routerLink]="item.path ? [item.path] : null"
                [class.hover:bg-destructive-50]="
                  item.action === sidenavAction.LOGOUT
                "
                [class.hover:text-destructive-700]="
                  item.action === sidenavAction.LOGOUT
                "
                [class.hover:bg-neutral-50]="
                  item.action !== sidenavAction.LOGOUT
                ">
                <div class="flex items-center">
                  <div [class.pe-sm]="!isCollapsed()">
                    @if (item.iconTemplate) {
                      <ng-container
                        [ngTemplateOutlet]="item.iconTemplate"
                        [ngTemplateOutletContext]="{ $implicit: false }" />
                    }
                  </div>

                  @if (!isCollapsed()) {
                    <span class="text-xs font-medium">
                      {{ item.label }}
                    </span>
                  }
                </div>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>

@if (!isCollapsed()) {
  <div
    class="block lg:hidden w-full h-full bg-black opacity-50 absolute top-0 start-0 z-1 overflow-hidden"
    (click)="toggleSidenav()"></div>
}
